export default "__VITE_ASSET__D4dKLH5Z__"